export default "__VITE_ASSET__DAaMEonw__"